__turbopack_context__.v({
  "actions": "styles-module-scss-module__4RKgpa__actions",
  "close": "styles-module-scss-module__4RKgpa__close",
  "drawerContent": "styles-module-scss-module__4RKgpa__drawerContent",
  "drawerHeader": "styles-module-scss-module__4RKgpa__drawerHeader",
  "header": "styles-module-scss-module__4RKgpa__header",
  "panel": "styles-module-scss-module__4RKgpa__panel",
  "summary": "styles-module-scss-module__4RKgpa__summary",
  "title": "styles-module-scss-module__4RKgpa__title",
});
